import { SWReactIcons } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";
import { GAWidgetTexts } from "app/pages/activation/components/GAWidget/texts";
import type { ConfigSchema } from "app/pages/activation/components/GAWidget/types";
import { EMPTY_DATA, METRIC_NAMES } from "app/pages/activation/components/GAWidget/widgetsConfig";
import { getInvertedArrowsNames } from "app/pages/activation/helpers/getInvertedArrowsNames";
import type { GAGraphData } from "app/pages/activation/types/api";

import { BenchmarkGranularity } from "../../../types/common";

import {
    Change,
    ChangeValueWrapper,
    ChangeWrapper,
    EmptyChange,
    GranularityIndicator,
    MetricValue,
    ValueWrapper,
} from "./styles";

type GraphChangeSchema = {
    isConnected: boolean;
    isSwSource?: boolean;
    isInverted: boolean;
    valueFormatter: ConfigSchema["valueFormatter"];
    graphData?: GAGraphData;
    metricName: string;
    changeFormatter: ConfigSchema["changeFormatter"];
    granularity: BenchmarkGranularity;
};

export const GraphChange = ({
    isConnected,
    isSwSource,
    valueFormatter,
    graphData,
    metricName,
    changeFormatter,
    granularity,
    isInverted,
}: GraphChangeSchema) => {
    const isIncrease = graphData?.change > 0;
    const isGrow = isInverted ? !isIncrease : isIncrease;

    const arrowName = getInvertedArrowsNames(isInverted, isIncrease);

    const isEmptyChange = graphData?.change === null;
    const isWeekly = granularity === BenchmarkGranularity.WEEKLY;
    let granularityText = isWeekly ? translate(GAWidgetTexts.wow) : translate(GAWidgetTexts.mom);

    const isUniqueUsers = metricName === METRIC_NAMES.UNIQUE_VISITORS;
    const isUniqueOnWeekly = isUniqueUsers && isWeekly && isSwSource;

    if (isUniqueOnWeekly) {
        granularityText = translate(GAWidgetTexts.uniqueUsersPlaceholder);
    }

    const metricValue = isConnected ? valueFormatter(graphData?.absolute) : "-";

    return (
        <ValueWrapper>
            <MetricValue>{metricValue}</MetricValue>
            <ChangeWrapper>
                {isConnected && !isUniqueOnWeekly ? (
                    !isEmptyChange ? (
                        <ChangeValueWrapper>
                            <SWReactIcons
                                iconName={arrowName}
                                size="xs"
                                className="centered"
                            />
                            <Change isIncrease={isGrow}>{changeFormatter?.(graphData?.change)}</Change>
                        </ChangeValueWrapper>
                    ) : (
                        <EmptyChange>{EMPTY_DATA}</EmptyChange>
                    )
                ) : null}

                <GranularityIndicator>{granularityText}</GranularityIndicator>
            </ChangeWrapper>
        </ValueWrapper>
    );
};
